<template>
  <div>
    <div class="print-container bg-white">
      <div v-if="!loadingData">
        <div class="d-flex align-items-center justify-content-center mb-2">
          <SecondaryButton
            name="Imprimir"
            class="print-button mr-2"
            @clicked="print"
          ></SecondaryButton>
          <SecondaryButton
            :width="2"
            name="Voltar"
            class="print-button"
            @clicked="goToHome"
          ></SecondaryButton>
        </div>

        <header class="row">
          <div class="col-10">
            <h5 class="print-title mb-1">Relatório</h5>
            <p class="print-subtitle">
              {{ keepingSectorData.bairro_nome }} |
              <span class="print-local">{{
                keepingSectorData.zeladoria_nome
              }}</span>
            </p>
            <div class="legal-text">
              {{ legalText }}
            </div>
          </div>
          <div class="col-2">
            <img :src="urlLogo" alt="logo" width="200" />
          </div>
        </header>

        <div v-if="engineers.length > 0" class="engineers mt-4">
          <h3 class="mb-2 response-label">Responsável técnico</h3>
          <div class="engineers d-flex flex-wrap">
            <div
              class="engineer mt-2 mb-2"
              v-for="engineer in engineers"
              :key="engineer.engenheiro_id"
            >
              <div class="pr-5">
                <p class="mb-1">{{ engineer.engenheiro_nome }}</p>
                <p>
                  CREA: {{ engineer.engenheiro_crea }}, ART
                  {{ engineer.engenheiro_art }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <hr class="divisor" />

        <section class="d-flex w-100 justify-content-between mb-1">
          <p class="activities-subtitle">
            Atividades |<span class="ml-2"
              >{{ this.dates[0].split("T")[0].split("-").reverse().join("/") }}
              -
              {{
                this.dates[1].split("T")[0].split("-").reverse().join("/")
              }}</span
            >
          </p>
        </section>

        <section class="counter-box-container">
          <div class="counter-box p-3">
            <div>
              <div class="counter-title">Execuções</div>
              <div class="counter-number">{{ executions.length }}</div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <svg
                width="45"
                height="44"
                viewBox="0 0 45 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_5380_5833)">
                  <path
                    d="M18.6721 27.2768L17.4602 25.9685C17.1146 25.5954 16.532 25.5731 16.1589 25.9187L16.0367 26.032C15.6636 26.3776 15.6413 26.9602 15.9869 27.3333L17.1988 28.6416C17.5444 29.0147 18.127 29.0369 18.5001 28.6913L18.6224 28.5781C18.9955 28.2325 19.0177 27.6499 18.6721 27.2768Z"
                    fill="#5CCDF2"
                  />
                  <path
                    d="M29.0625 24.5C30.961 24.5 32.5 22.961 32.5 21.0625C32.5 19.164 30.961 17.625 29.0625 17.625C27.164 17.625 25.625 19.164 25.625 21.0625C25.625 22.961 27.164 24.5 29.0625 24.5Z"
                    fill="#5C7B9B"
                  />
                  <path
                    d="M19.6667 30.7747C20.2723 30.8142 20.8802 30.8003 21.4833 30.7331L22.0833 30.6372H22.1167C25.3625 30.0122 27.875 28.1372 29.5875 25.1039C31.2542 22.1331 31.4292 18.7581 30.1 14.7872C30.0055 14.4353 29.8234 14.1132 29.5705 13.8508C29.3176 13.5885 29.0024 13.3946 28.6542 13.2872C28.2955 13.2129 27.9238 13.2308 27.574 13.3394C27.2242 13.448 26.9077 13.6437 26.6542 13.9081C25.8827 14.6728 24.8842 15.1669 23.8083 15.3164C22.6375 15.4581 21.45 15.5247 20.3042 15.5914H20.0667C18.7577 15.6002 17.4706 15.9277 16.3167 16.5456C13.1458 18.4331 11.25 22.5247 13.75 26.7039C13.811 26.8037 13.8639 26.9082 13.9083 27.0164L14.0292 27.3122L13.8542 27.5747C13.3996 28.2744 12.9823 28.9976 12.6042 29.7414C12.5899 29.7728 12.5825 29.8069 12.5825 29.8414C12.5825 29.8759 12.5899 29.91 12.6042 29.9414C12.6139 29.9741 12.6304 30.0044 12.6527 30.0302C12.675 30.0561 12.7024 30.0769 12.7333 30.0914C12.7637 30.1072 12.7968 30.1168 12.8309 30.1197C12.865 30.1226 12.8993 30.1187 12.9319 30.1083C12.9644 30.0978 12.9946 30.081 13.0206 30.0588C13.0466 30.0366 13.0679 30.0094 13.0833 29.9789C13.8231 28.51 14.732 27.1326 15.7917 25.8747L16.2083 25.3789L16.6667 25.8456C16.9 26.0831 17.1917 26.3872 17.4667 26.6789C17.5171 26.7308 17.586 26.7608 17.6583 26.7622C17.7251 26.763 17.7894 26.7376 17.8375 26.6914C17.8882 26.6435 17.9181 26.5777 17.9208 26.5081C17.9221 26.4737 17.9165 26.4394 17.9044 26.4072C17.8922 26.375 17.8737 26.3455 17.85 26.3206C17.4792 25.9247 17.2125 25.6456 17.0167 25.4414L16.6 24.9956L17.0542 24.5789C17.7312 23.9453 18.468 23.3788 19.2542 22.8872C20.2671 22.2234 21.3991 21.7621 22.5875 21.5289C22.6569 21.5195 22.7198 21.4833 22.7627 21.4279C22.8056 21.3726 22.825 21.3026 22.8167 21.2331C22.8126 21.199 22.8017 21.1661 22.7848 21.1363C22.7679 21.1065 22.7451 21.0804 22.718 21.0594C22.6908 21.0385 22.6598 21.0232 22.6267 21.0144C22.5935 21.0055 22.559 21.0034 22.525 21.0081C21.2731 21.2381 20.0801 21.717 19.0167 22.4164L18.075 22.9914V21.8872C18.075 21.6831 18.075 21.4706 18.075 21.2831C18.0755 21.2484 18.0691 21.214 18.0563 21.1818C18.0434 21.1496 18.0243 21.1203 18 21.0956C17.9519 21.0453 17.8862 21.0154 17.8167 21.0122C17.7478 21.0111 17.6812 21.0371 17.6313 21.0847C17.5814 21.1322 17.5522 21.1975 17.55 21.2664C17.5167 22.3081 17.5125 22.8247 17.55 23.1039V23.4122L17.3125 23.6081C16.4392 24.341 15.6408 25.1589 14.9292 26.0497L14.4042 26.7331L13.9667 25.9539C13.4868 25.0616 13.2218 24.0697 13.1929 23.057C13.164 22.0442 13.3719 21.0388 13.8 20.1206C14.1874 19.2052 14.7875 18.3954 15.5506 17.7584C16.3137 17.1215 17.2176 16.6757 18.1875 16.4581C19.1501 16.2803 20.1255 16.1813 21.1042 16.1622L21.8375 16.1289C23.6375 16.0247 25.5042 15.7456 26.95 14.3872C27.625 13.7539 28.2 13.7414 28.5375 13.8456C28.875 13.9497 29.3708 14.2622 29.5792 15.1497C29.9088 16.331 30.147 17.536 30.2917 18.7539C30.449 20.2076 30.2964 21.6782 29.844 23.0686C29.3915 24.4591 28.6494 25.7378 27.6667 26.8206C26.6745 27.8907 25.4686 28.7403 24.1271 29.3146C22.7855 29.8888 21.3383 30.1748 19.8792 30.1539H19.7875C19.7238 30.1531 19.6604 30.1629 19.6 30.1831C19.5705 30.1891 19.5422 30.2003 19.5167 30.2164C19.4786 30.2433 19.4474 30.2789 19.4257 30.3202C19.404 30.3614 19.3923 30.4073 19.3917 30.4539C19.3877 30.4932 19.3917 30.5329 19.4035 30.5706C19.4153 30.6083 19.4347 30.6433 19.4604 30.6733C19.4861 30.7033 19.5177 30.7277 19.5531 30.7452C19.5886 30.7626 19.6272 30.7727 19.6667 30.7747Z"
                    fill="black"
                  />
                </g>
                <rect
                  x="1"
                  y="0.5"
                  width="43"
                  height="43"
                  rx="21.5"
                  stroke="#C6C9D0"
                />
                <defs>
                  <clipPath id="clip0_5380_5833">
                    <rect
                      width="20"
                      height="20"
                      fill="white"
                      transform="translate(12.5 12)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>
          <div class="counter-box p-4">
            <div>
              <div class="counter-title">Fotos</div>
              <div class="counter-number">{{ photosTotal }}</div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5206 19.9287H14.0331C12.9378 19.9287 12.0498 20.8167 12.0498 21.912V28.1287C12.0498 29.2241 12.9378 30.112 14.0331 30.112H14.5206C15.616 30.112 16.504 29.2241 16.504 28.1287V21.912C16.504 20.8167 15.616 19.9287 14.5206 19.9287Z"
                  fill="#5CCDF2"
                />
                <path
                  d="M27.221 23.696C28.9584 23.696 30.3669 22.2875 30.3669 20.5501C30.3669 18.8127 28.9584 17.4043 27.221 17.4043C25.4836 17.4043 24.0752 18.8127 24.0752 20.5501C24.0752 22.2875 25.4836 23.696 27.221 23.696Z"
                  fill="#5C7B9B"
                />
                <path
                  d="M30.3581 29.7836H30.6123C30.8219 29.7741 31.0266 29.7175 31.2113 29.6179C31.3959 29.5184 31.5558 29.3785 31.679 29.2086C31.8664 28.9469 31.9616 28.6303 31.9498 28.3086C31.9498 26.4795 31.9498 24.6253 31.9498 22.8295V19.9461C31.9498 19.1128 31.9498 18.2795 31.9498 17.4461C31.9556 17.1728 31.8793 16.904 31.7307 16.6745C31.5822 16.4449 31.3682 16.2653 31.1165 16.1586C30.8957 16.0646 30.6557 16.0246 30.4165 16.042H28.4373C28.2679 16.0613 28.0973 16.017 27.9587 15.9177C27.8201 15.8184 27.7234 15.6711 27.6873 15.5045L27.5498 15.1128V15.0795L27.4165 14.7211C27.3488 14.4701 27.1966 14.2501 26.9856 14.0983C26.7746 13.9465 26.5176 13.8721 26.2581 13.8878H23.0248C22.7679 13.8731 22.514 13.9482 22.3064 14.1002C22.0989 14.2523 21.9507 14.4718 21.8873 14.7211C21.8373 14.8545 21.7915 14.9878 21.7456 15.1378L21.5831 15.5795C21.5473 15.6927 21.4786 15.7927 21.3859 15.8668C21.2932 15.941 21.1806 15.986 21.0623 15.9961C20.8638 16.0066 20.6649 16.0066 20.4665 15.9961H20.1248V15.7045C20.1248 15.5378 20.1248 15.3836 20.1248 15.2295C20.1251 15.0254 20.047 14.8291 19.9066 14.681C19.7663 14.5329 19.5744 14.4443 19.3706 14.4336C18.6248 14.4336 17.8998 14.4336 17.0331 14.4336C16.9257 14.4357 16.8202 14.4618 16.7243 14.5101C16.6283 14.5584 16.5445 14.6277 16.479 14.7128C16.4559 14.7331 16.4374 14.7581 16.4248 14.7862C16.4121 14.8142 16.4056 14.8446 16.4056 14.8753C16.4056 14.906 16.4121 14.9364 16.4248 14.9644C16.4374 14.9925 16.4559 15.0175 16.479 15.0378C16.4977 15.0598 16.521 15.0774 16.5473 15.0895C16.5736 15.1016 16.6021 15.1079 16.631 15.1079C16.6599 15.1079 16.6885 15.1016 16.7148 15.0895C16.741 15.0774 16.7643 15.0598 16.7831 15.0378C16.8532 14.985 16.9333 14.9471 17.0186 14.9263C17.1038 14.9056 17.1924 14.9024 17.279 14.917H19.129C19.2094 14.9113 19.2902 14.9113 19.3706 14.917C19.4461 14.9245 19.5166 14.9582 19.5699 15.0122C19.6232 15.0662 19.6558 15.1372 19.6623 15.2128C19.6623 15.3836 19.6623 15.5545 19.6623 15.7336V16.0295H15.9581C15.806 16.0235 15.6536 16.0347 15.504 16.0628C15.183 16.1303 14.8961 16.3091 14.6941 16.5676C14.4921 16.826 14.3878 17.1475 14.3998 17.4753C14.3998 19.5586 14.3998 21.7253 14.3998 23.7961V25.9836C14.3954 26.028 14.3954 26.0726 14.3998 26.117C14.4088 26.1707 14.437 26.2192 14.4792 26.2537C14.5213 26.2882 14.5745 26.3062 14.629 26.3045C14.6831 26.307 14.7363 26.2892 14.7779 26.2545C14.8196 26.2198 14.8467 26.1707 14.854 26.117C14.8582 26.0559 14.8582 25.9947 14.854 25.9336V20.1336C14.854 19.2545 14.854 18.3461 14.854 17.4503C14.8483 17.2158 14.9308 16.9878 15.0851 16.8112C15.2393 16.6345 15.4542 16.5221 15.6873 16.4961C15.7788 16.4899 15.8707 16.4899 15.9623 16.4961H20.9081C21.1591 16.5128 21.4081 16.4423 21.6131 16.2965C21.8181 16.1508 21.9665 15.9387 22.0331 15.6961C22.0831 15.5586 22.129 15.417 22.179 15.2795V15.2461C22.2206 15.1211 22.2623 15.0003 22.3081 14.8795C22.3403 14.7254 22.4283 14.5886 22.5552 14.4955C22.6821 14.4025 22.839 14.3596 22.9956 14.3753H26.2831C26.4423 14.3534 26.604 14.3916 26.7365 14.4825C26.8691 14.5735 26.9629 14.7105 26.9998 14.867C27.0373 14.9795 27.079 15.0878 27.1165 15.2003C27.1706 15.3628 27.2331 15.5461 27.2998 15.7253C27.3579 15.9034 27.4615 16.0632 27.6003 16.1889C27.7392 16.3146 27.9085 16.4018 28.0915 16.442C28.2092 16.4665 28.3296 16.4763 28.4498 16.4711H30.4915C30.6851 16.4564 30.8784 16.5033 31.0438 16.6051C31.2092 16.7069 31.3382 16.8583 31.4123 17.0378C31.475 17.1969 31.5062 17.3668 31.504 17.5378C31.504 20.2128 31.504 22.9545 31.504 25.392V27.417C31.504 27.7128 31.504 28.0503 31.504 28.3836C31.5085 28.6259 31.4183 28.8603 31.2525 29.037C31.0867 29.2137 30.8585 29.3186 30.6165 29.3295C30.5123 29.3295 30.4039 29.3295 30.2998 29.3295H16.0873C15.9623 29.3295 15.8165 29.3295 15.6706 29.3295C15.5597 29.3188 15.452 29.2861 15.354 29.2331C15.2559 29.1802 15.1695 29.1081 15.0998 29.0211C14.9927 28.8953 14.9175 28.7456 14.8805 28.5846C14.8436 28.4236 14.8459 28.256 14.8873 28.0961V28.042H15.7498H16.7831C17.0679 28.0238 17.3348 27.8969 17.5287 27.6876C17.7226 27.4782 17.8286 27.2023 17.8248 26.917C17.8248 25.7295 17.8248 24.5128 17.8248 23.4378V23.3253C17.8248 22.5253 17.8248 21.7295 17.8248 20.9295C17.8309 20.7828 17.8075 20.6364 17.756 20.4989C17.7045 20.3615 17.6259 20.2358 17.5248 20.1293C17.4238 20.0228 17.3024 19.9377 17.1678 19.879C17.0332 19.8204 16.8882 19.7893 16.7415 19.7878C16.5748 19.7878 16.3998 19.7878 16.229 19.7878H16.1665C16.1153 19.7903 16.0648 19.8001 16.0165 19.817C15.9727 19.8334 15.9357 19.8642 15.9115 19.9043C15.8873 19.9443 15.8773 19.9914 15.8831 20.0378C15.883 20.0815 15.8978 20.1238 15.9251 20.1579C15.9524 20.192 15.9905 20.2158 16.0331 20.2253C16.1024 20.2439 16.1739 20.2523 16.2456 20.2503H16.7331C16.8916 20.2551 17.0426 20.3189 17.1566 20.429C17.2706 20.5392 17.3395 20.6879 17.3498 20.8461C17.3538 20.9058 17.3538 20.9656 17.3498 21.0253V26.7045C17.3477 26.7252 17.3477 26.7462 17.3498 26.767C17.3539 26.8336 17.3539 26.9004 17.3498 26.967C17.3372 27.0951 17.2863 27.2164 17.2038 27.3152C17.1214 27.4141 17.0111 27.4858 16.8873 27.5211C16.7922 27.5466 16.694 27.5578 16.5956 27.5545H14.7331C14.4748 27.5545 14.3998 27.6295 14.3998 27.8961V28.0086C14.3998 28.1378 14.3998 28.2711 14.3998 28.4045C14.406 28.6703 14.4877 28.929 14.6352 29.1503C14.7828 29.3716 14.9901 29.5464 15.2331 29.6545C15.4711 29.7497 15.7273 29.791 15.9831 29.7753H30.3581V29.7836Z"
                  fill="black"
                />
                <path
                  d="M21.804 18.0916C20.7591 18.6402 19.9286 19.5237 19.4454 20.6004C18.9622 21.6771 18.8544 22.8848 19.1391 24.0301C19.4239 25.1754 20.0848 26.192 21.016 26.9171C21.9471 27.6422 23.0947 28.0337 24.2749 28.0291C25.1784 28.0302 26.0668 27.7977 26.854 27.3541C27.8179 26.8115 28.5868 25.9797 29.052 24.9762C29.5172 23.9728 29.6553 22.8485 29.4466 21.7623C29.2379 20.6761 28.6931 19.6829 27.8891 18.9233C27.0852 18.1637 26.0628 17.6759 24.9665 17.5291C24.7303 17.4983 24.4921 17.4858 24.254 17.4916C24.2232 17.4904 24.1926 17.4957 24.1639 17.507C24.1353 17.5184 24.1094 17.5356 24.0878 17.5576C24.0662 17.5795 24.0494 17.6058 24.0386 17.6346C24.0278 17.6634 24.0231 17.6942 24.0249 17.725C24.0226 17.7556 24.0264 17.7864 24.0361 17.8156C24.0458 17.8448 24.0611 17.8718 24.0812 17.895C24.1014 17.9182 24.1259 17.9373 24.1534 17.951C24.1809 17.9647 24.2109 17.9729 24.2415 17.975C24.2817 17.9792 24.3222 17.9792 24.3624 17.975H24.3915C25.0933 17.9918 25.7823 18.1655 26.4082 18.4833C27.3708 18.9648 28.1423 19.7577 28.5973 20.7332C29.0523 21.7086 29.1641 22.8092 28.9145 23.8562C28.665 24.9032 28.0687 25.835 27.2226 26.5003C26.3765 27.1656 25.3303 27.5252 24.254 27.5208C24.0578 27.5226 23.8616 27.5129 23.6665 27.4916C22.5082 27.3447 21.4442 26.7778 20.6761 25.8984C19.9081 25.019 19.4896 23.8883 19.4999 22.7208C19.4997 21.8608 19.7359 21.0173 20.1827 20.2825C20.6294 19.5477 21.2696 18.9498 22.0332 18.5541L22.1124 18.5125C22.1601 18.4895 22.206 18.463 22.2499 18.4333C22.3 18.4029 22.3367 18.3544 22.3522 18.2978C22.3677 18.2412 22.3609 18.1809 22.3332 18.1291C22.3136 18.0882 22.2829 18.0536 22.2446 18.0292C22.2063 18.0049 22.1619 17.9919 22.1165 17.9916H22.0415C21.9719 18.0152 21.9049 18.0459 21.8415 18.0833L21.804 18.0916Z"
                  fill="black"
                />
                <path
                  d="M27.8334 22.7123C27.8308 22.5435 27.8169 22.3751 27.7917 22.2081C27.7223 21.739 27.5583 21.2888 27.3098 20.8848C27.0613 20.4809 26.7333 20.1316 26.3459 19.8581C25.7395 19.419 25.0112 19.1801 24.2625 19.1748C24.0629 19.1747 23.8635 19.1915 23.6667 19.2248C22.8285 19.3774 22.0707 19.82 21.526 20.4752C20.9813 21.1303 20.6845 21.9562 20.6875 22.8081C20.6995 23.7447 21.0786 24.6392 21.7433 25.2992C22.4079 25.9592 23.305 26.3319 24.2417 26.3373H24.2667C25.1167 26.3333 25.9377 26.0277 26.5834 25.4748C26.8855 25.2284 27.1385 24.9273 27.3292 24.5873C27.3476 24.5605 27.3601 24.5302 27.3659 24.4982C27.3717 24.4662 27.3706 24.4334 27.3627 24.4018C27.3548 24.3703 27.3403 24.3408 27.3202 24.3153C27.3 24.2898 27.2747 24.2689 27.2459 24.254C27.1923 24.2217 27.1284 24.211 27.0672 24.2242C27.0061 24.2374 26.9522 24.2733 26.9167 24.3248C26.8917 24.3581 26.8709 24.3915 26.85 24.4248C26.8362 24.4493 26.8209 24.473 26.8042 24.4956C26.407 25.074 25.825 25.5001 25.1537 25.7039C24.4823 25.9077 23.7617 25.8771 23.11 25.6171C22.4584 25.3572 21.9145 24.8833 21.5678 24.2734C21.2211 23.6635 21.0921 22.9538 21.2021 22.2609C21.3121 21.5679 21.6545 20.9331 22.173 20.4605C22.6916 19.9879 23.3554 19.7057 24.0555 19.6603C24.7557 19.6149 25.4504 19.809 26.0256 20.2107C26.6008 20.6124 27.0223 21.1977 27.2209 21.8706C27.2738 22.0757 27.31 22.2847 27.3292 22.4956C27.3292 22.5748 27.3292 22.654 27.3584 22.7331C27.3834 22.9081 27.4834 23.0123 27.6167 23.004C27.6502 22.9994 27.6825 22.9882 27.7116 22.971C27.7408 22.9537 27.7662 22.9309 27.7864 22.9037C27.8065 22.8765 27.8211 22.8456 27.8292 22.8127C27.8372 22.7799 27.8387 22.7457 27.8334 22.7123Z"
                  fill="black"
                />
                <path
                  d="M25.7834 15.5044C25.7334 15.5044 23.5584 15.5044 23.5084 15.5044C23.4514 15.5107 23.3987 15.5381 23.3609 15.5813C23.3231 15.6245 23.3029 15.6804 23.3043 15.7378C23.3028 15.7956 23.3229 15.852 23.3606 15.8959C23.3983 15.9397 23.451 15.968 23.5084 15.9753C23.5501 15.9753 25.7043 15.9753 25.7793 15.9753C25.8374 15.9676 25.8907 15.939 25.9293 15.895C25.968 15.8509 25.9893 15.7943 25.9893 15.7357C25.9893 15.6771 25.968 15.6205 25.9293 15.5764C25.8907 15.5323 25.8374 15.5038 25.7793 15.4961L25.7834 15.5044Z"
                  fill="black"
                />
                <path
                  d="M30.1376 27.6129H28.9876C28.9323 27.6056 28.8762 27.6056 28.8209 27.6129C28.7745 27.6275 28.7341 27.6571 28.7063 27.697C28.6784 27.737 28.6645 27.785 28.6667 27.8337C28.6616 27.8838 28.673 27.9342 28.6994 27.9772C28.7258 28.0201 28.7655 28.0531 28.8126 28.0712C28.872 28.0892 28.9339 28.0976 28.9959 28.0962H30.1251C30.2386 28.1025 30.3507 28.0686 30.4417 28.0004C30.4791 27.9563 30.4985 27.8997 30.4959 27.842C30.4917 27.6962 30.3709 27.6129 30.1376 27.6129Z"
                  fill="black"
                />
                <path
                  d="M29.3791 26.3747C29.3768 26.4048 29.3805 26.435 29.39 26.4637C29.3994 26.4924 29.4145 26.5189 29.4342 26.5418C29.454 26.5646 29.478 26.5833 29.505 26.5968C29.532 26.6104 29.5614 26.6184 29.5916 26.6205C29.8206 26.633 30.0501 26.633 30.2791 26.6205C30.3366 26.6164 30.3906 26.5912 30.4306 26.5496C30.4706 26.5081 30.4938 26.4532 30.4957 26.3955C30.4981 26.3334 30.4765 26.2728 30.4354 26.2263C30.3942 26.1797 30.3368 26.1508 30.2749 26.1455H29.5957C29.5382 26.1514 29.4846 26.1778 29.4449 26.2199C29.4051 26.2619 29.3818 26.3169 29.3791 26.3747Z"
                  fill="black"
                />
                <path
                  d="M17.4709 17.417C17.277 17.417 17.0875 17.4745 16.9264 17.5823C16.7653 17.6901 16.6398 17.8433 16.5658 18.0224C16.4918 18.2016 16.4727 18.3987 16.5108 18.5887C16.5489 18.7788 16.6426 18.9532 16.78 19.09C16.9173 19.2268 17.0922 19.3197 17.2824 19.357C17.4726 19.3943 17.6696 19.3743 17.8485 19.2996C18.0273 19.2248 18.1799 19.0987 18.287 18.9371C18.3941 18.7756 18.4508 18.5858 18.45 18.392C18.45 18.2636 18.4247 18.1365 18.3754 18.0179C18.3262 17.8994 18.254 17.7917 18.163 17.7011C18.072 17.6105 17.964 17.5388 17.8453 17.49C17.7265 17.4413 17.5992 17.4165 17.4709 17.417ZM18.0459 18.392C18.0467 18.5059 18.0137 18.6175 17.951 18.7126C17.8883 18.8077 17.7988 18.882 17.6938 18.9262C17.5888 18.9704 17.4731 18.9823 17.3613 18.9606C17.2494 18.9389 17.1466 18.8845 17.0658 18.8042C16.9849 18.724 16.9298 18.6215 16.9072 18.5099C16.8847 18.3982 16.8958 18.2824 16.9392 18.1771C16.9826 18.0718 17.0563 17.9817 17.151 17.9184C17.2456 17.855 17.357 17.8212 17.4709 17.8212C17.6205 17.8211 17.7643 17.8794 17.8717 17.9836C17.979 18.0879 18.0415 18.2299 18.0459 18.3795V18.392Z"
                  fill="black"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="43"
                  height="43"
                  rx="21.5"
                  stroke="#C6C9D0"
                />
              </svg>
            </div>
          </div>
          <!-- <div class="counter-box p-4">
            <div>
              <div class="counter-title">Tempo total de execução</div>
              <div class="counter-number">
                {{ formatMilisecondsToTime(totalExecutionTime) }}
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-center">
              <svg
                width="44"
                height="44"
                viewBox="0 0 44 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.0458 23.1539L22.5708 20.1289L21.0917 23.1539C20.9958 23.3622 20.9375 23.5914 20.9375 23.8331C20.9375 24.7331 21.6667 25.4622 22.5667 25.4622C23.4667 25.4622 24.1958 24.7331 24.1958 23.8331C24.1958 23.5914 24.1375 23.3622 24.0417 23.1539H24.0458Z"
                  fill="#5CCDF2"
                />
                <path
                  d="M26.925 21.2874C29.3297 21.2874 31.2791 19.338 31.2791 16.9333C31.2791 14.5285 29.3297 12.5791 26.925 12.5791C24.5202 12.5791 22.5708 14.5285 22.5708 16.9333C22.5708 19.338 24.5202 21.2874 26.925 21.2874Z"
                  fill="#5C7B9B"
                />
                <path
                  d="M27.204 26.9005C27.6124 26.3005 28.1374 25.288 28.3124 23.8546V23.8213C28.3332 23.7505 28.3249 23.6796 28.2999 23.6213C28.229 23.4671 28.0499 23.3963 27.8915 23.463C27.729 23.5338 27.7124 23.6755 27.6999 23.7796C27.5415 25.0713 26.9082 27.388 24.4124 28.363V28.3546C24.1665 28.5213 23.0915 28.8255 22.2832 28.8255H22.2124L22.204 28.5796C22.204 28.4796 22.1999 28.3755 22.1957 28.2838C22.1874 28.0838 22.079 27.963 21.9082 27.963C21.7332 27.963 21.629 28.0796 21.6249 28.2838C21.6249 28.3921 21.6249 28.4963 21.6249 28.6046V28.8255H21.5499C18.304 28.6921 16.0457 25.8046 16.0415 23.2963V23.2255H16.4207C16.8332 23.2255 16.8915 23.0713 16.8915 22.9421C16.8915 22.863 16.8707 22.8046 16.829 22.763C16.7582 22.6921 16.6249 22.6505 16.429 22.6505C16.3499 22.6505 16.2707 22.6463 16.1915 22.6421L15.9999 22.6338L16.0082 22.5588C16.0124 22.5046 16.0165 22.4546 16.0207 22.4046C16.029 22.3005 16.0374 22.2088 16.0499 22.1171C16.4499 19.3671 18.6457 17.2796 21.3874 17.0505C24.6124 16.7796 26.954 19.0046 27.5999 21.3463C27.6332 21.4755 27.6624 21.6088 27.6915 21.738C27.7165 21.8463 27.7374 21.9546 27.7665 22.063C27.7749 22.0921 27.7832 22.1213 27.7957 22.1463C27.8415 22.2505 27.9374 22.3171 28.0499 22.3171C28.1999 22.3171 28.3207 22.1963 28.3207 22.0463C28.3207 22.038 28.3207 22.0296 28.3207 22.0213C28.3249 21.963 28.3124 21.9046 28.304 21.8505L28.2957 21.8046C27.7707 18.713 24.954 16.4463 21.8915 16.4463C21.5582 16.4463 21.2207 16.4713 20.8874 16.5296C18.9415 16.8505 17.2665 18.013 16.2874 19.7255C15.3124 21.4255 15.1582 23.4421 15.854 25.2588C16.7915 27.7005 19.0832 29.3338 21.6915 29.4213C21.7124 29.4213 21.7249 29.4213 21.7374 29.4213H21.8749C22.004 29.4213 22.1332 29.4213 22.2665 29.413C23.3915 29.363 24.3874 29.113 25.2249 28.6713C26.0249 28.2505 26.6915 27.6546 27.2082 26.9005H27.204Z"
                  fill="black"
                />
                <path
                  d="M30.7039 22.9338C30.7039 22.7713 30.6998 22.6088 30.6914 22.4421C30.6956 22.3921 30.6956 22.3546 30.6914 22.3171C30.5998 21.113 30.2831 19.9796 29.7456 18.9421C29.3914 18.2421 28.9414 17.5963 28.4164 17.013L28.3748 16.9671L28.8789 16.3713L28.9331 16.4255C28.9664 16.4588 28.9956 16.488 29.0248 16.513C29.0831 16.5713 29.1331 16.6213 29.1914 16.6671C29.3248 16.7796 29.4789 16.7796 29.5873 16.6671C29.6998 16.5505 29.7039 16.388 29.5998 16.2755C29.2748 15.938 28.9289 15.588 28.5748 15.2463C28.4539 15.1296 28.2998 15.1296 28.1789 15.2421C28.0623 15.3546 28.0623 15.5171 28.1789 15.6546C28.2289 15.7171 28.2873 15.7713 28.3414 15.8255L28.4539 15.938L27.9248 16.5088L27.8706 16.4588C26.6664 15.3421 25.1831 14.588 23.5831 14.2713L23.5248 14.2588V14.2005C23.5248 14.1005 23.5248 14.0005 23.5248 13.9005C23.5248 13.6838 23.5248 13.4713 23.5248 13.263C23.5081 12.6921 23.0664 12.2505 22.4998 12.2338C22.1498 12.2255 21.7748 12.2255 21.2873 12.2338C21.0039 12.238 20.7581 12.3505 20.5539 12.563C20.4664 12.6546 20.3456 12.838 20.5206 13.0088C20.6331 13.1213 20.7831 13.1088 20.9581 12.9755C21.0998 12.8671 21.2206 12.813 21.3331 12.8088C21.6498 12.7921 21.9748 12.7963 22.2873 12.8005H22.4581C22.7206 12.8046 22.9081 12.9505 22.9331 13.1671C22.9581 13.3838 22.9539 13.6046 22.9456 13.8171C22.9456 13.9046 22.9414 13.9963 22.9414 14.0838V14.1671L22.8623 14.1588C20.2998 13.8755 17.7831 14.713 15.9081 16.4421L15.8581 16.488L15.2873 15.9088L15.3498 15.8588C15.3789 15.838 15.4081 15.813 15.4373 15.7921C15.4956 15.7463 15.5539 15.7046 15.5998 15.6546C15.7248 15.5213 15.7289 15.3588 15.6164 15.2421C15.4956 15.1213 15.3373 15.1213 15.2081 15.2421C14.8706 15.5671 14.5289 15.9088 14.1998 16.2546C14.0873 16.3713 14.0831 16.5338 14.1914 16.6505C14.3081 16.7713 14.4664 16.7713 14.6039 16.6505C14.6664 16.6005 14.7206 16.5463 14.7789 16.4921L14.9039 16.3755L15.4456 16.9005L15.3956 16.9546C14.4581 17.9713 13.7664 19.2088 13.3914 20.5296C13.2123 21.1421 13.1081 21.7796 13.0748 22.4213C13.0664 22.5921 13.0581 22.763 13.0581 22.9296C13.0581 24.5713 13.5164 26.1796 14.3831 27.5713C16.3039 30.6963 19.9039 32.2796 23.5581 31.613C23.6373 31.6005 23.7039 31.5796 23.7581 31.5546C27.7914 30.6671 30.7039 27.0463 30.7039 22.9296V22.9338ZM21.8789 31.188C18.1456 31.188 14.8664 28.6713 13.9039 25.063L13.8789 24.9713C13.5664 23.7213 13.5539 22.4671 13.8373 21.2296C14.0373 20.3463 14.3373 19.5338 14.7331 18.8088C15.4873 17.5046 16.5831 16.4296 17.9039 15.7046C18.5873 15.3546 19.3456 15.0838 20.1664 14.9088C20.9123 14.7463 21.6498 14.6755 22.3581 14.6963C23.8456 14.7838 25.2831 15.2713 26.5164 16.1088C27.1873 16.588 27.8206 17.1921 28.3998 17.9005C28.5123 18.038 28.6206 18.1838 28.7289 18.3338C29.6498 19.6963 30.1331 21.288 30.1331 22.9338C30.1331 27.4838 26.4289 31.188 21.8789 31.188Z"
                  fill="black"
                />
                <path
                  d="M21.8581 24.5082C21.5498 24.5082 21.2456 24.4332 20.9831 24.2874C20.6706 24.1124 20.4248 23.8624 20.254 23.5332C20.1915 23.4124 20.2373 23.2582 20.3581 23.1957C20.479 23.1332 20.6331 23.179 20.6956 23.2999C20.8206 23.5374 20.9998 23.7249 21.2248 23.8499C21.5915 24.054 22.0581 24.0624 22.4748 23.8749C23.3456 23.4832 23.354 22.5082 23.1623 22.0707C22.9165 21.5082 22.2498 20.129 21.9165 19.4415L20.704 21.9915C20.6456 22.1165 20.4956 22.1707 20.3706 22.1082C20.2456 22.0499 20.1915 21.8999 20.254 21.7749L21.729 18.679L21.9165 18.6582C22.0248 18.6582 22.129 18.7207 22.1748 18.8207C22.2206 18.9124 23.2873 21.0999 23.6248 21.8665C23.9248 22.554 23.8331 23.8124 22.6831 24.329C22.4206 24.4457 22.1415 24.504 21.8665 24.504L21.8581 24.5082Z"
                  fill="black"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="43"
                  height="43"
                  rx="21.5"
                  stroke="#C6C9D0"
                />
              </svg>
            </div>
          </div> -->
        </section>

        <section
          style="position: relative"
          class="mb-4 fullscreenMapOpen mr-1 ml-1"
        >
          <GoogleMaps
            ref="childMap"
            :tracking="tracking"
            :polygons="polygons"
            :bounds="bounds"
            :pins="[]"
            :zoomControl="false"
            :changeMapType="true"
            mapView="satellite"
          />
        </section>

        <div
          v-for="execution in executions"
          :key="execution.execucao_uuid"
          class="mr-3 ml-3"
        >
          <section class="day-resume-box mb-3">
            <section class="day-resume-box-header row align-items-center p-3">
              <div class="d-flex col-2 pt-3">
                <span class="legend">{{ execution.counter }}.</span>
                <div class="d-flex flex-column align-items-start ml-3">
                  <p class="legend">
                    {{ execution.hora_inicio }}
                  </p>
                  <p class="legend d-flex align-items-center">
                    {{ formatDate(execution.execucao_data_criacao) }}
                  </p>
                  <!-- <p class="legend d-flex align-items-center">
                    {{ formatMilisecondsToTime(execution.executionTime) }}
                  </p> -->
                </div>
              </div>
              <div class="d-flex align-items-center col-4">
                <div class="divider text-white mr-5" />
                <div
                  class="legend d-flex flex-column justify-content-center align-items-start pt-2"
                >
                  <div class="mb-2">
                    <b>
                      {{ execution.atividade_nome }}
                    </b>
                  </div>
                  <div class="mt-2 d-flex flex-wrap align-items-center">
                    <p class="mr-2"><b>Zelador:</b></p>
                    <p style="text-align: left">{{ execution.usuario_nome }}</p>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-start col-4"
              >
                <div class="divider text-white mr-5" />
                <div
                  v-if="execution.photos && execution.photos.length"
                  class="legend"
                >
                  {{ execution.photos.length }}
                  {{ execution.photos.length > 1 ? "Fotos" : "Foto" }}
                </div>
                <div v-else class="legend">
                  <div v-if="tags.length">
                    <div>Nenhuma foto encontrada com as tags:</div>
                    <div
                      v-for="tag of tagsLabel"
                      :key="tag.tag_id"
                      class="tags-list"
                    >
                      {{ tag.tag_descricao }}
                    </div>
                  </div>
                  <div v-else>Nenhuma foto encontrada</div>
                </div>
              </div>
            </section>

            <div class="d-flex flex-wrap photos-container">
              <li
                v-for="photo in execution.photos"
                :key="photo.execucao_timeline_uuid"
                class="d-flex align-items-center justify-content-between"
              >
                <div class="gallery-container">
                  <div>
                    <img
                      class="item"
                      :src="photo.execucao_timeline_foto"
                      width="230"
                      height="230"
                      :alt="
                        photo.tags[0]
                          ? photo.tags[0].tag_descricao
                          : 'Foto da execução'
                      "
                    />
                    <div class="d-flex align-items-top mt-2 ml-1">
                      <div>
                        <div class="pinMarker mr-3 mt-2">
                          <span class="pinCounter">{{ photo.index }}</span>
                        </div>
                      </div>
                      <div class="mt-2" v-if="photo.tags">
                        <div class="photo-subtitle" v-if="photo.tags[0]">
                          {{ photo.tags[0].tag_descricao }}
                        </div>
                        <div class="photo-subtitle" v-if="!photo.tags[0]">
                          -
                        </div>
                        <div class="photo-hour mt-2 font-weight-bold">
                          {{ formatTime(photo.execucao_timeline_data) }}
                        </div>
                        <div class="mt-2 text-sm-left photoLatLng">
                          {{ photo.execucao_timeline_lat }},
                          {{ photo.execucao_timeline_lng }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </div>
          </section>
        </div>
      </div>
      <div v-else style="height: calc(100vh - 66px)" class="bg-white pb-4">
        <div
          style="height: 100%; width: 100%"
          class="d-flex justify-content-center align-items-center mb-4 pb-4"
        >
          <img
            :src="require(`@/assets/img/loading.gif`)"
            class="mb-4 pday-resume-box-galleryb-4"
            alt="AMA carregando"
            width="150"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleMaps from "../../components/IndexComponents/GoogleMaps.vue";
import SecondaryButton from "../../components/SecondaryButton.vue";
import services from "../../services";
import { decrypt } from "../../utils/decrypt";
import { formatForGoogleMaps } from "../../utils/geoMaps";
import { formatMilisecondsToTime } from "../../utils/date";

export default {
  name: "PrintScreen",
  components: {
    GoogleMaps,
    SecondaryButton,
  },
  mounted: async function () {
    await this.initAllData();
    this.logoUrl();
  },
  data() {
    return {
      pins: [],
      polygons: [],
      bounds: [],
      loadingData: true,
      keepingSectorId: 0,
      keepingSectorData: null,
      dates: [],
      tags: [],
      tagsLabel: [],
      activities: [],
      itemCounter: 0,
      urlLogo: "",
      executions: [],
      tracking: [],
      generalIndex: 1,
      photosTotal: 0,
      totalExecutionTime: 0,
      engineers: [],
      legalText: "Lorem ipsum",
      formatMilisecondsToTime,
    };
  },
  methods: {
    async initAllData() {
      this.keepingSectorId = this.$route.params.id;
      this.dates = this.$store.state.global.printBackup.dates;
      this.tags = this.$store.state.map.stateTags;
      this.activities =
        this.$store.state.global.printBackup.relatoryKeepingSector.activities.filter(
          (activity) => activity.active
        );
      if (!this.activities.length)
        this.activities =
          this.$store.state.global.printBackup.relatoryKeepingSector.activities;
      await this.requestKeepingSectorLimit();
      await this.requestExecutionFilter();
      this.loadingData = false;
      this.setheatMAP();
      this.fitBounds();
      await this.requestTags();
      await this.getLegalText();
      await this.requestPhotosTotal();
      await this.requestExecutionEngineers();
    },
    async logoUrl() {
      const encrypted = localStorage.getItem("ama");
      const decrypted = decrypt(encrypted);
      const user = JSON.parse(decrypted);
      this.urlLogo = user.cidade_logo;
    },
    async requestKeepingSectorLimit() {
      const { data, errors } =
        await services.keepingSectors.getKeepingSectorLimitsById({
          keepingSectorId: this.keepingSectorId,
        });
      if (!errors) {
        this.keepingSectorData = data[0];
        await this.formatKeepingSectorToRender(data);
      }
    },
    setheatMAP() {
      let point = [];
      this.tracking.forEach((item) => {
        if (item.tracking !== undefined) {
          item.tracking.forEach((track) => {
            point.push({
              location: this.googlePoints(track),
              weight: 100,
            });
          });
        }
      });
      setTimeout(() => {
        this.$refs.childMap.generateHeatmap(point);
      }, 700);
    },
    googlePoints(value) {
      let map = new window.google.maps.LatLng(value.lat, value.lng);
      return map;
    },
    async getLegalText() {
      const { data, errors } = await services.importData.getLegalText(201);
      if (!errors) {
        this.legalText = data.config_valor;
      }
    },
    async requestTags() {
      const { data, errors } = await services.tags.getTags();
      if (!errors) {
        this.tagsLabel = data.filter((item) => {
          return this.tags.includes(item.tag_id);
        });
      }
    },
    async requestExecutionTimeline(id) {
      this.photoCounter = 1;
      this.totalExecutionTime = 0;
      const { data, errors } = await services.executions.postExecutionTimeline({
        execucao_uuid: [id],
        intervalo: 0.05,
        tag_id: this.tags,
      });
      if (data.execucao_uuid && !errors) {
        this.executions.forEach((item) => {
          if (item.execucao_uuid === id) {
            item.photos = data.execucao_timeline ? data.execucao_timeline : [];
            this.totalExecutionTime += data.tempo_execucao_ms || 0;
            item.executionTime = data.tempo_execucao_ms;
            item.photosNumber = data.execucao_timeline
              ? data.execucao_timeline.length
              : 0;
            let executionTracking = {
              tracking: this.convertTrackingToLatLng(data.execucao_tracking),
              id: data.execucao_uuid,
              active: true,
            };
            this.tracking.push(executionTracking);
            item.photos.forEach((photo) => {
              this.pins.push({
                center: {
                  lat: photo.execucao_timeline_lat,
                  lng: photo.execucao_timeline_lng,
                },
                tag_nome: photo.tags[0] ? photo.tags[0].tag_descricao : "",
                atividade_id: photo.execucao_timeline_uuid,
                quantidade: this.photoCounter,
                id: item.execucao_uuid,
              });
              photo.index = this.photoCounter;
              this.photoCounter++;
            });
          }
        });
      }
    },
    async requestExecutionEngineers() {
      const { data, errors } = await services.executions.getExecutionsEngineers(
        {
          data_inicio: this.dates[0],
          data_fim: this.dates[1],
        }
      );
      if (!errors) this.engineers = data;
    },
    async requestPhotosTotal() {
      let countPhotos = 0;
      this.executions.forEach((item) => {
        countPhotos += item.photosNumber;
      });
      this.photosTotal = countPhotos;
    },
    convertTrackingToLatLng(arrayOfXAndY) {
      let arrayOfLatLng = [];
      if (!arrayOfXAndY || arrayOfXAndY?.length === 0) {
        return [];
      }
      arrayOfXAndY.forEach((item) => {
        arrayOfLatLng.push({
          lat: item.x,
          lng: item.y,
        });
      });
      return arrayOfLatLng;
    },
    async requestExecutionFilter() {
      const { data, errors } = await services.executions.executionFilter({
        data_inicio: this.dates[0],
        data_fim: this.dates[1],
        zeladoria_id: this.keepingSectorId,
      });
      if (data.length > 0 && !errors) {
        this.executions = data.map((item) => {
          let found = false;

          this.activities.forEach((activity) => {
            if (activity.atividade_id === item.atividade_id) {
              found = true;
            }
          });

          return found
            ? {
                ...item,
                data_inicio: this.formatDate(item.execucao_data_criacao),
                hora_inicio: this.formatTime(item.execucao_data_criacao),
                hora_fim: this.formatTime(item.execucao_data_fim),
                counter: ++this.itemCounter,
              }
            : null;
        });
        this.executions = this.executions.filter((item) => item !== null);
        if (this.executions.length) {
          await Promise.all(
            this.executions.map(async (item) => {
              await this.requestExecutionTimeline(item.execucao_uuid);
            })
          );
        }
        let counter = 1;
        this.executions.forEach((execution) => {
          if (execution.photos) {
            execution.photos.forEach((photo) => {
              photo.index = counter++;
            });
          }
        });
      }
    },
    async formatKeepingSectorToRender(data) {
      data.map((item, index) => {
        if (item.zeladoria_limite !== "" && item.zeladoria_limite !== null) {
          let zeladoria = {
            latlngs: formatForGoogleMaps(item.zeladoria_limite[0]),
            center: {
              lat: item.zeladoria_lat,
              lng: item.zeladoria_lng,
            },
            options: {
              strokeColor: item.avaliacao_quadra_cor,
              fillColor: item.avaliacao_quadra_cor,
            },
            zeladoria_id: item.zeladoria_id,
            zeladoria_nome: item.zeladoria_nome,
            id: index,
            display_name: false,
          };
          zeladoria.latlngs.map((item) => {
            this.bounds.push(item);
          });
          this.polygons.push(zeladoria);
        }
      });
    },
    print() {
      setTimeout(function () {
        window.print();
      }, 0);
    },
    goToHome() {
      this.$router.push({
        name: "index",
        params: {
          searchStoreKeepingSector: true,
        },
      });
    },
    fitBounds() {
      setTimeout(() => {
        this.$refs.childMap.fitBoundsGoogle();
      }, 700);
    },
    formatDate(date) {
      return date.split("T")[0].split("-").reverse().join("/");
    },
    formatTime(time) {
      return time.split("T")[1].split(":").slice(0, 2).join(":");
    },
  },
};
</script>

<style scoped>
@media print {
  @page {
    size: A4 !important;
  }

  .print-button {
    display: none;
  }

  .day-resume-box-header {
    background-color: #e2f4ff;
    top: 20px;
  }

  .day-resume-box {
    display: block;
    position: relative;
    top: 40px;
    page-break-before: auto;
    page-break-after: auto;
    page-break-inside: avoid;
  }

  img {
    display: block;
    page-break-inside: avoid;
  }

  .fullscreenMapOpen {
    display: block;
    page-break-inside: avoid;
    max-width: none !important;
    max-height: none !important;
  }
}

.print-container {
  padding: 50px 120px 90px 120px;
}

.counter-box {
  display: flex;
  flex: 1 1 auto;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #c6c9d0;
  border-radius: 16px;
  height: 100px;
}

.fullscreenMapOpen {
  height: 500px;
  border-radius: 16px;
}

.day-resume-box {
  width: 100%;
  border-radius: 12px;
}

.day-resume-box-header {
  background: #e2f4ff !important;
  border-radius: 12px 12px 0px 0px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #003366;
}

.counter-box-container {
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  gap: 16px;
}

.divider {
  font-size: 2.5rem;
}

.divider::before {
  content: "";
  border: 1px solid #b8e9f9;
}

.gallery-container {
  display: flex;
  flex-wrap: wrap;
  padding: 24px;
  justify-content: space-between;
}

.photo-subtitle,
.photo-hour {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  color: #565e73;
}

.photoLatLng {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 10px;
  line-height: 156%;
  color: #838998;
}

.item {
  min-height: 210px;
  min-width: 210px;
}

.legend {
  font-family: "OpenSans-Regular";
  font-weight: 600;
  font-size: 14px;
  line-height: 156%;
  color: #005976;
}

.pinMarker {
  position: relative;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #003063;
  margin-bottom: 5px;
}

.pinCounter {
  position: absolute;
  color: #fff;
  width: 100%;
  text-align: center;
  left: 0;
  right: 0;
  top: 7px;
  font-size: 15px;
  font-weight: bold;
}

.counter-title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 16px;
  line-height: 160%;
  letter-spacing: -0.014em;
  color: #565e73;
}

.photos-container {
  margin-left: -37px;
  margin-right: -37px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.counter-number {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #29334e;
}

.divisor {
  border: 1px solid #e4e4e4;
  margin-bottom: 30px;
}

.activities-subtitle {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.014em;
  color: #565e73;
}

.activities-date {
  font-family: "OpenSans-Regular";
  color: #61b2e5;
  font-weight: 400;
}

.print-title {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 20px;
  line-height: 32px;
  color: #565e73;
}

.print-subtitle {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: #565e73;
}

.tags-list {
  background-color: #61b2e5;
  border-radius: 8px;
  margin-top: 6px;
  width: fit-content;
  padding: 2px 6px;
  color: #fff;
}

.print-local {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 156%;
  color: #00b1eb;
}

.engineers {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 12px;
  line-height: 145%;
  color: #747474;
}

.response-label {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #565e73;
}

.legal-text {
  font-family: "OpenSans-Regular";
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #747474;
}

@media print {
  .mapTypeControllers {
    display: none !important;
  }
}
</style>
